



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { PMWorksheet } from '@/models/pmworksheet';
import type { Project } from '@/models/project';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { PMLesson } from '@/models/pmlesson';
import type { PMPhase } from '@/models/pmphase';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';

import { pmPhaseWebservice } from '@/webservices/pmphase';
import { pmSubPhaseWebservice } from '@/webservices/pmsubphase';
import { pmWorksheetWebservice } from '@/webservices/pmWorksheet';
import PrineButton from '@/components/prine/PrineButton.vue';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { extractTagsFrom } from '@/helpers/extractTags';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'CreateWorksheetPM',
    methods: { extractTagsFrom },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class CreateWorksheetPM extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<PMLesson>();
    private pmSubPhases = new Array<PMSubPhase>();
    private filteredPmSubPhases = new Array<PMSubPhase>();
    private selectedPMPhase: PMPhase = {} as PMPhase;

    private option: {
        filterByColumn: boolean;
        filterable: boolean;
    };
    private pmWorksheet: PMWorksheet = {} as PMWorksheet;
    private isLoading: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredPmSubPhases = filterLessonContainer(
            JSON.parse(JSON.stringify(this.pmSubPhases)) as PMSubPhase[],
            this.filters
        );
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredPmSubPhases, this.checkedLessons);
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('phaseId')) {
            this.loadSelectedPhase(this.$route.query.phaseId);
        } else {
            this.goBack();
        }
    }

    private goBack() {
        this.$router.go(-1);
    }

    private loadSelectedPhase(phaseId) {
        pmPhaseWebservice.getById(phaseId).then((response) => {
            this.selectedPMPhase = response.data;
            this.loadSubPhasesWithLessons();
        });
    }

    private loadSubPhasesWithLessons() {
        pmSubPhaseWebservice.load(this.selectedPMPhase.id, ApprovalState.APPROVED).then((response) => {
            this.pmSubPhases = response.data;
            this.filterLessons();
            this.preselectMandatoryLessons();
        });
    }

    private preselectMandatoryLessons() {
        this.pmSubPhases.forEach((subPhase) => {
            this.selectLessonsIfMandatory(subPhase.lessons);
        });
    }

    private selectLessonsIfMandatory(lessons: PMLesson[]) {
        lessons.forEach((lesson: PMLesson) => {
            if (lesson.mandatory) {
                this.checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
                this.selectLessonsIfMandatory(lesson.sub_lessons);
            }
        });
    }

    private selectAllClick() {
        console.log(this.allSelected);
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredPmSubPhases, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredPmSubPhases, this.checkedLessons);
        }
    }

    private createWorksheet() {
        this.pmWorksheet.pm_phase = this.selectedPMPhase;
        this.pmWorksheet.project = this.selectedProject;
        this.isLoading = true;

        pmWorksheetWebservice
            .store(this.pmWorksheet, this.checkedLessons)
            .then((response) => {
                // Store the worksheet id
                this.pmWorksheet.id = response.data;

                // Show the Worksheet View
                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: this.pmWorksheet.id.toString(),
                        type: 'pm',
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }

    private hr(index) {
        return index > 1;
    }
}
